import VectorSource from 'ol/source/Vector';
import VectorLayer from 'ol/layer/Vector';
import {Style, Stroke,Fill,Circle } from 'ol/style.js';
import GeoJSON from 'ol/format/GeoJSON.js';
import {Modify} from 'ol/interaction.js';

export const style = new Style({
   	 	stroke: new Stroke({
            color: '#00264A',
            width: 3
          }),
          fill: new Fill({
            color: 'rgba(0, 0, 255, 0.1)'
          }),
          image: new Circle({
	          radius: 6,
	          stroke: new Stroke({
	            color: '#00264A',
	            width: 4
	          }),
	          fill: new Fill({
	            color: 'rgba(0, 0, 255, 0.1)'
	          })
        })
	});	


export const drawSource = new VectorSource({});

export const drawLayer = new VectorLayer({
	source: drawSource,
	zIndex: 6,
	style: style
});

export const getGeometries = function() {

	var features = drawSource.getFeatures();

	var data = [];
	/*for (var i = 0, len = features.length; i < len; i++) {
		var geom = features[i].getGeometry();


	}*/

	var format = new GeoJSON;

	return format.writeFeaturesObject(features);

};

export const modify = new Modify({source: drawSource});

var modifyInProgress = false;

modify.on('modifystart', (ev)=>{

	modifyInProgress = true;
});

modify.on('modifyend', (ev)=>{

	modifyInProgress = false;
});

export const isModifyInProgress = () => {

	return modifyInProgress;
}